import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const ResultsLayoutDataHooks = createDataHooks('resultsLayout', 'voucherInHeader');
//# sourceMappingURL=dataHooks.js.map